/* ======================  SCRIPTS ====================== */
/************  JQUERY EST DISPONIBLE ICI *****************/

    var numSlide = 1;
    let firstClick = 0;
    let checkboxByClickDimensions = true;

    $('document').ready(setup);
    $(window).on('load', documentReady);

    function setup() {
        if($(window).width() >= 760) initScrollReveal();
        initTarteAuCitron();
        initSliderHomeHeader();
        adaptMenu();
        transformSelectbox();
        adjustLinksInResponsiveMenu();
        adaptGridLogosBlock();
        adjustLandingPageForm();
        $(window).scroll(stickyMenu);
        $(window).resize(adaptMenu);
        $('a').click(detectIfAncre);
        $('#block-navigationprincipale, #block-navigationprincipaleenglish, #block-navigationprincipaledutch').show();
        $('.selectbuttonstext li').click(switchTextShowed);
        $('.slidertextblock .btn-next').click(changeNextSlide);
        $('.slidertextblock .btn-prev').click(changePrevSlide);
        $('.topage').click(goBackToTop);
        $('.logosblock-grid').slick({
            dots: true,
            arrows: false,
            infinite: true,
            variablewidth: true,
            autoplay: true,
            autoplaySpeed: 4000,
            slidesToShow: 7,
            slidesToScroll: 3,
            responsive: [
              {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 3,
                }
            },
                {
                    breakpoint: 770,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        dots: false,
                        arrows: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }]
        });
        $('#solutionsform').submit(redirectToSolutionPage);
        $('.webform-button--submit').click(verifForm);
        $('.showmegamenu').mouseenter(showMegaMenu);
        $('.burger').click(showHideMenuResponsive);
        $('.navigation .language').click(showHideLangMenu);
        $('.videoportrait').click(showModalVideo);
        $('#openYoutubeModal').click(showModalHeaderVideo);
        $('.js-form-item select').change(applyFilter);
        $('.search .btn-search').click(showHideSearchBlock);
        $('.newsletterblock .sendinblueform .btn').click(testNewsletterForm);
        $('.newsletterblock form').submit(testNewsletterForm);
        $('.landingpage-slider .nextbutton, .landingpage-slider .prevbutton').click(showNextPrevSlide);
        $('#btnVerifClickDim').click(verifClickDimensionsForm);
        $('.faqblock .question').click(showHideFaqAnwser);
    }

    function documentReady() {
        initMasonry();
        initContactMap();
        clickDimensionInputCenter();
        $(window).resize(adjustLandingPageForm);
        if($('#edit-submit').length !== 0) $('#edit-submit').val('OK');
    }

    // Fonction qui permet d'initialiser le bandeau des cookies avec tarteaucitron
    function initTarteAuCitron() {
        tarteaucitron.init({
          "privacyUrl": "",
          "hashtag": "#agena3000",
          "cookieName": "agena3000",
          "orientation": "middle",
          "groupServices": false,
          "showDetailsOnClick": true,
          "serviceDefaultState": "wait",
          "showAlertSmall": true,
          "cookieslist": false,
          "closePopup": false,
          "showIcon": false,
          "iconPosition": "BottomRight",
          "adblocker": false,
          "DenyAllCta" : true,
          "AcceptAllCta" : true,
          "highPrivacy": true,
          "handleBrowserDNTRequest": false,
          "removeCredit": true,
          "moreInfoLink": true,
          "useExternalCss": true,
          "useExternalJs": false,
          "readmoreLink": "",
          "mandatory": true,
          "mandatoryCta": true,
          "googleConsentMode": true,
          "partnersList": false
        });

        if(window.location.href.indexOf('agena3000.com') !== -1) {
          tarteaucitron.user.gtagUa = 'G-P1XV5HW4ZS';
          tarteaucitron.user.gtagMore = function () { /* add here your optionnal gtag() */ };
          (tarteaucitron.job = tarteaucitron.job || []).push('gtag');
          tarteaucitron.user.clickDimAccount = 'avuwPPnoFRkiaqRGLqj4BU';
          tarteaucitron.user.clickDimDomain = 'agena3000.com';
          (tarteaucitron.job = tarteaucitron.job || []).push('clickdimensions');
          (tarteaucitron.job = tarteaucitron.job || []).push('gcmadstorage');
          (tarteaucitron.job = tarteaucitron.job || []).push('gcmanalyticsstorage');
          (tarteaucitron.job = tarteaucitron.job || []).push('gcmfunctionality');
          (tarteaucitron.job = tarteaucitron.job || []).push('gcmpersonalization');
          (tarteaucitron.job = tarteaucitron.job || []).push('gcmadsuserdata');
          (tarteaucitron.job = tarteaucitron.job || []).push('gcmsecurity');
        }

        //(tarteaucitron.job = tarteaucitron.job || []).push('zendesk');
        tarteaucitron.user.crispID = 'dbbf561b-e24f-48a3-a07d-0cae1a1490db';
        (tarteaucitron.job = tarteaucitron.job || []).push('crisp');
        (tarteaucitron.job = tarteaucitron.job || []).push('zoominfo');
        (tarteaucitron.job = tarteaucitron.job || []).push('youtube');
    }

    // Fonction qui permet d'animer les blocs
    function initScrollReveal() {
        /* ANIMATION DU HEADER */
        ScrollReveal().reveal('.blockpushdouble .h2-title, .pictosblock .h2-title', { delay: 300, duration: 1000, easing: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)', opacity: 0, scale: 0.9, distance: '50px', origin: 'bottom' });
        ScrollReveal().reveal('.solutions li', { delay: 800, duration: 800, easing: 'ease-in-out', opacity: 0, distance: '30px', origin: 'bottom', useDelay: 'always', interval: 80 });
        ScrollReveal().reveal('.header-btns', { delay: 500, duration: 800, easing: 'ease-in-out', opacity: 0, distance: '50px', origin: 'bottom' });
        if($(window).width() > 1200) { ScrollReveal().reveal('.navigation-menu', { delay: 10, duration: 600, easing: 'cubic-bezier(0.77, 0, 0.175, 1)', opacity: 0, distance: '50px', origin: 'top' }); }

        /* ANIMATION Bloc Logos / Bloc Newsletter */
        ScrollReveal().reveal('.logosblock-grid, .gridlogosblock', { delay: 100, duration: 1400, easing: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)', opacity: 0, distance: '80px', origin: 'bottom' });

        /* ANIMATION BLOC DE CARTES */
        ScrollReveal().reveal('.card', { delay: 20, duration: 1600, easing: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)', opacity: 0, scale: 0.5, distance: '20px', origin: 'bottom',  interval: 100 });

        /* ANIMATION BLOC PUSH  */
        ScrollReveal().reveal('.blockpush-btns', { delay: 20, duration: 1500, easing: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)', opacity: 0, scale: 0.2, distance: '0px', origin: 'right' });

        /* ANIMATION BLOC pictos */
        ScrollReveal().reveal('.pictosblock-pictos li', { delay: 300, duration: 1700, easing: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)', opacity: 0, scale: 0.9, distance: '10px', origin: 'top',  interval: 100 });
        ScrollReveal().reveal('.pictosblock-intro p', { delay: 200, duration: 1500, easing: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)', opacity: 0, distance: '80px', origin: 'bottom' });

        /* ANIMATION Bloc Points Clés */
        ScrollReveal().reveal('.benefitsblock-points li:nth-child(even)', { delay: 50, duration: 1200, easing: 'cubic-bezier(0.77, 0, 0.175, 1)', opacity: 0, distance: '200px', origin: 'right',  interval: 150 });
        ScrollReveal().reveal('.benefitsblock-points li:nth-child(odd)', { delay: 150, duration: 1200, easing: 'cubic-bezier(0.77, 0, 0.175, 1)', opacity: 0, distance: '200px', origin: 'left',  interval: 200 });

        /* ANIMATION Bloc Fonctionnalités Clés & MASONRY */
        ScrollReveal().reveal('.keypointsblock .buttons', { delay: 100, duration: 1500, easing: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)', opacity: 0, scale: 0, distance: '0px', origin: 'left' });
        ScrollReveal().reveal('.masonryblock', { delay: 400, duration: 1800, easing: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)', opacity: 0, distance: '100px', origin: 'bottom', cleanup: true });


        /* ANIMATION Bloc texte image grille */
        ScrollReveal().reveal('.textpicturesblock .grid li', { delay: 50, duration: 1700, easing: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)', opacity: 0, scale: 0.5, distance: '10px', origin: 'top',  interval: 100 });

        /* ANIMATION AUTRES ELEMENTS */
        ScrollReveal().reveal('.cloudtagblock-grid li', { delay: 160, duration: 1000, easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)', opacity: 0, scale: 0.1, distance: '5px', origin: 'top',  interval: 150 });
        ScrollReveal().reveal('.cardoffer', { delay: 160, duration: 1400, easing: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)', opacity: 0, distance: '80px', origin: 'top',  interval: 180 });
        ScrollReveal().reveal('.formblock', { delay: 300, duration: 1200, easing: 'cubic-bezier(0.77, 0, 0.175, 1)', opacity: 0, distance: '200px', origin: 'bottom', viewOffset: { top: -60 }, afterReveal: adjustLandingPageForm });

        if($(window).width() < 1200) {
            $('.navigation-menu, .slidertextblock .h2-title, .slidertextblock-img, .selectbuttonstext li, .switchcontent').removeAttr('style');
        }else {
            ScrollReveal().reveal('.navigation-menu', { delay: 10, duration: 600, easing: 'cubic-bezier(0.77, 0, 0.175, 1)', opacity: 0, distance: '50px', origin: 'top' });
        }
    }

    function initSliderHomeHeader() {
      if($('.header-slider').length !== 0) {

        $('.header-slider .slider').slick({
          dots: true,
          arrows: true,
          infinite: false,
          variableWidth: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          appendArrows: $('.header-slider .slicknav'),
          appendDots: $('.header-slider .dotsnav'),
        });
      }
    }

    // Fonction qui permet de rendre le menu sticky
    function stickyMenu() {
        if($('.navigation').length != 0) {
            if(($(this).scrollTop() > ($('.navigation').offset().top + $('.navigation').innerHeight() + 200)) && $('.navigation.sticky').length == 0)  {
                $('.navigation').clone().appendTo('body').addClass('sticky');
                $('.sticky .navigation-surnav').hide();
                $('.sticky .logo').hide();
                $('.sticky .logo-color').show();
                $('.sticky').slideDown(300);
                $('.showmegamenu').mouseenter(showMegaMenu);
                $('.navigation-submenu').addClass('stickyMegaMenu');
                $('.navigation.sticky .openSubmenuBtn').click(openSubMenuWithBtn);
                $('.navigation.sticky .btn-main-white').addClass('btn-main');
                $('.navigation.sticky .btn-main-white').removeClass('btn-main-white');
                $('#block-navigationprincipale, #block-navigationprincipaleenglish, #block-navigationprincipaledutch').addClass('isSticky');
                $('#block-navigationprincipale, #block-navigationprincipaleenglish, #block-navigationprincipaledutch').append('<button class="btn btn-close open">Fermer le menu</button>');
                $('#block-navigationprincipale .btn-close, #block-navigationprincipaleenglish .btn-close, #block-navigationprincipaledutch .btn-close').click(showHideMenuResponsive);
                $('.navigation.sticky .burger').click(showHideMenuResponsive);
                $('.navigation.sticky .search .btn-search').click(showHideSearchBlock);
            }else if(($(this).scrollTop() < ($('.navigation').offset().top + $('.navigation').innerHeight())) && $('.navigation.sticky').length != 0) {
                $('.sticky').slideUp(300, function() { if($('.sticky').length != 0) $('.sticky').remove(); });
                $('.navigation-submenu').removeClass('stickyMegaMenu');
                $('#block-navigationprincipale, #block-navigationprincipaleenglish, #block-navigationprincipaledutch').removeClass('isSticky');
                $('#block-navigationprincipale .btn-close, #block-navigationprincipaleenglish .btn-close, #block-navigationprincipaledutch .btn-close').remove();
            }

            if($(window).width() > 1024) {
                if($(this).scrollTop() > $('.header').height() - 100){
                    if($(this).scrollTop() >= $('.footer').offset().top - 500) {
                        $('.telecommand').fadeOut(100);
                    }else {
                        $('.telecommand').fadeIn(300);
                    }
                }else {
                    $('.telecommand').fadeOut(100);
                }
            }
        }
    }

    // Fonction qui permet d'afficher/cacher le selecteur de langue
    function showHideLangMenu() {
      if($(this).parent().find('.language-dropdown').hasClass('active')) {
        $(this).parent().find('.language-dropdown').removeClass('active');
      }else {
        $(this).parent().find('.language-dropdown').addClass('active');
      }
    }

    // Fonction qui permet de transformer le champ select des besoins
    function transformSelectbox() {
        var selectedOption = $('.selectBox select').find(":selected").text();
        $('.selectBox .selectBox-select').append('<div class="select-selected">' + selectedOption + '</div>');
        $('.selectBox .selectBox-select').append('<ul class="select-items"></ul>');
        $('.selectBox select option').each(function() {
            if(selectedOption == $(this).text()) {
                $('.selectBox .select-items').append('<li class="selected" data-value="' + $(this).val() + '">' + $(this).text() + '</li>');
            }else {
                $('.selectBox .select-items').append('<li data-value="' + $(this).val() + '">' + $(this).text() + '</li>');
            }
        });
        $('.selectBox .select-selected').click(function() {
            if($(this).hasClass('open')) {
                $(this).removeClass('open');
                $('.selectBox .select-items').slideUp();
            }else {
                $(this).addClass('open');
                $('.selectBox .select-items').slideDown();
            }
        });
        $('.selectBox .select-items li').click(function() {
            if($(this).hasClass('selected') == false) {
                $('.selectBox .select-items .selected').removeClass('selected');
                $(this).addClass('selected');
                $('.selectBox .select-selected').html($(this).text());
                $('.selectBox .select-selected').removeClass('open');
                $('.selectBox .select-items').slideUp();
                var value = $(this).attr('data-value');
                $('.selectBox select option').each(function() {
                    $(this).removeAttr('selected');
                    if($(this).val() == value) $(this).attr("selected","selected");
                });
            }
        });
        $('body').click(function(event) {
            if($(event.target).attr('class') != undefined) {
                if($(event.target).attr('class').indexOf('open') == -1) {
                    $('.selectBox .select-items').slideUp();
                    $('.selectBox .open').removeClass('open');
                }
            }
        });
    }

    // Fonction qui permet de gérer le bloc slider avec changement de texte affiché au clic sur un bouton
    function switchTextShowed() {
        if($(this).hasClass('current') == false) {
            $(this).parent().children('.current').removeClass('current');
            $(this).addClass('current');
            var textId = $(this).attr('data-id');
            var imgClass = $(this).attr('data-picto');
            var imgSliderURL = $(this).attr('data-image');
            var imgSliderURLIE = $(this).attr('data-image-ie');
            if(imgClass != undefined) {
                $(this).parent().parent().children('.slidertextblock-img').children('img').fadeOut(200, function() {
                    $(this).attr('src', imgClass);
                    $(this).fadeIn(500);
                });
            }
            if(imgSliderURL != undefined && (imgSliderURLIE == undefined || imgSliderURLIE == '/')) {
                $(this).parent().parent().parent().children('.switchtextblock-img').children('img').fadeOut(200, function() {
                    $(this).attr('src', imgSliderURL);
                    $(this).fadeIn(500);
                });
            }else if(imgSliderURL != undefined && imgSliderURLIE != undefined) {
                $(this).parent().parent().parent().children('.switchtextblock-img').children('.forIe').fadeOut(200, function() {
                    $(this).attr('src', imgSliderURLIE);
                    $(this).fadeIn(500);
                });
                $(this).parent().parent().parent().children('.switchtextblock-img').children('.notIe').fadeOut(200, function() {
                    $(this).attr('src', imgSliderURL);
                    $(this).fadeIn(500);
                });
            }

            $(this).parent().parent().children('.switchcontent').fadeOut(300, function() {
                $(this).children('.currentslide').removeClass('currentslide');
                $(this).children('.text-' + textId).addClass('currentslide');
                $(this).fadeIn(400);
            });
        }
    }

    // Fonction qui permet de passer à la slide suivante dans le slider texte
    function changeNextSlide() {
       if($('.slidertextblock .selectbuttonstext .current').next().length != 0) {
           var currentButton = $('.slidertextblock .selectbuttonstext .current');
           var currentText = $('.slidertextblock .switchcontent .currentslide');
           currentButton.removeClass('current');
           currentButton.next().addClass('current');
           $('.switchcontent').fadeOut(300, function() {
               currentText.removeClass('currentslide');
               currentText.next().addClass('currentslide');
               $(this).fadeIn(400);
           });
           var imgClass = currentButton.next().attr('data-picto');
           if(imgClass != undefined) {
               $('.slidertextblock-img img').fadeOut(200, function() {
                   $(this).attr('src', imgClass);
                   setTimeout(function() { $('.slidertextblock-img img').fadeIn(500); }, 200);
               });
           }
       }else {
           $('.slidertextblock .selectbuttonstext .current').removeClass('current');
           $('.slidertextblock .selectbuttonstext li:first-child').addClass('current');
           $('.switchcontent').fadeOut(300, function() {
               $('.slidertextblock .switchcontent .currentslide').removeClass('currentslide');
               $('.slidertextblock .switchcontent .slider:first-child').addClass('currentslide');
               $(this).fadeIn(400);
           });
           var imgClass = $('.slidertextblock .selectbuttonstext li:first-child').attr('data-picto');
           if(imgClass != undefined) {
               $('.slidertextblock-img img').fadeOut(200, function() {
                   $(this).attr('src', imgClass);
                   setTimeout(function() { $('.slidertextblock-img img').fadeIn(500); }, 200);
               });
           }
       }
    }

    // Fonction qui permet de passer à la slide précédente dans le slider texte
    function changePrevSlide() {
        if($('.slidertextblock .selectbuttonstext .current').prev().length != 0) {
            var currentButton = $('.slidertextblock .selectbuttonstext .current');
            var currentText = $('.slidertextblock .switchcontent .currentslide');
            currentButton.removeClass('current');
            currentButton.prev().addClass('current');
            $('.switchcontent').fadeOut(300, function() {
                currentText.removeClass('currentslide');
                currentText.prev().addClass('currentslide');
                $(this).fadeIn(400);
            });
            var imgClass = currentButton.prev().attr('data-picto');
            if(imgClass != undefined) {
                $('.slidertextblock-img img').fadeOut(200, function() {
                    $(this).attr('src', imgClass);
                    setTimeout(function() { $('.slidertextblock-img img').fadeIn(500); }, 200);
                });
            }
        }else {
            $('.slidertextblock .selectbuttonstext .current').removeClass('current');
            $('.slidertextblock .selectbuttonstext li:last-child').addClass('current');
            $('.switchcontent').fadeOut(300, function() {
                $('.slidertextblock .switchcontent .currentslide').removeClass('currentslide');
                $('.slidertextblock .switchcontent .slider:last-child').addClass('currentslide');
                $(this).fadeIn(400);
            });
            var imgClass = $('.slidertextblock .selectbuttonstext li:last-child').attr('data-picto');
            if(imgClass != undefined) {
                $('.slidertextblock-img img').fadeOut(200, function() {
                    $(this).attr('src', imgClass);
                    setTimeout(function() { $('.slidertextblock-img img').fadeIn(500); }, 200);
                });
            }
        }
    }

    // Fonction qui permet de revenir en haut de page
    function goBackToTop() {
        $('html, body').animate({scrollTop: 0}, 1500);
    }

    // Fonction qui permet de rediriger vers les pages solutions en fonction du besoin
    function redirectToSolutionPage(e) {
        e.preventDefault();
        var selectedNeeds = $('#solutionsform select').find(":selected").val();
        window.location.replace(window.location.protocol + selectedNeeds);
    }

    // Fonction qui permet de générer le masonry du bloc Chiffres clés
    function initMasonry() {
        if($(window).width() <= 1200) {
            var gutter = 15;
        }else {
            var gutter = 25;
        }
        if($('.masonryblock').length != 0) {
            $('.masonryblock .grid').masonry({
                gutter: gutter,
                itemSelector: '.grid-item'
            });
        }
    }

    // Fonction qui permet de contrôler les saisies des formulaires
    function verifForm(e) {
        // vérification des saisies utilisateurs
        var nbChampVide = 0;
        $('div.error').remove();
        $('select.error').removeClass('error');
        $('select.valid').removeClass('valid');
        $('input.error').removeClass('error');
        $('input.valid').removeClass('valid');

        // On vérifie que l'utilisateur a coché les cases RGPD
        $('input[type="checkbox"].required').each(function () {
            if($(this).prop( "checked" ) == false) {
                $(this).parent().children('label').after('<div class="error">' + $(this).attr('data-webform-required-error') + '</div>');
                $('.error').fadeIn();
                nbChampVide++;
            }
        });

        // On vérifie s'il y a des select list obligatoire
        $('select.required').each(function () {
            if($(this).val() == '' || $(this).val() == ' ') {
                $(this).addClass('error');
                $(this).parent().append('<div class="error">' + $(this).attr('data-webform-required-error') + '</div>');
                $('.error').fadeIn();
                nbChampVide++;
            }
        });

        // On vérifier s'il y a des checkbox obligatoires
        $('.checkboxes--wrapper.required').each(function() {
            var nbEmptyChecked = 0;
            $(this).children('.fieldset-wrapper').children('.form-checkboxes').children('.js-form-item').each(function() {
                if($(this).children('input').prop('checked') == true) nbEmptyChecked++;
            });
            if(nbEmptyChecked == 0) {
                $(this).append('<div class="error">' + $(this).attr('data-webform-required-error') + '</div>');
                $('.error').fadeIn();
                nbChampVide++;
            }
        });

        // On vérifie s'il y a des fichiers à transmettre
        $('.js-form-type-managed-file').each(function() {
          if($('#block-navigationprincipale').length !== 0) {
            var message = 'Veuillez transférer un fichier.';
          }else if($('#block-navigationprincipaleenglish').length !== 0) {
            var message = 'Please upload a file.';
          }else {
            var message = 'Upload een bestand.';
          }
            if($(this).children('label.form-required').length != 0 ) {
               if($(this).children('.js-form-managed-file').children('input[type="file"]').val() == '' || $(this).children('.js-form-managed-file').children('input[type="file"]').val() == ' ') {
                   $(this).parent().append('<div class="error"></div>');
                   $('.error').fadeIn();
                   nbChampVide++;
               }
            }
        });

        // On vérifie la saisie des champs obligatoire
        $('.webform-submission-form input:not(.webform-button--submit)').each(function() {
            if($(this).attr('required') == 'required') {
                var textError = $(this).attr('data-webform-required-error');
                if($(this).val() == "" || $(this).val() == " ") { // On vérifie que le champ n'est pas vide
                    nbChampVide++;
                    $(this).addClass('error');
                    $(this).parent().append( "<div class='error'>" + textError + "</div>" );
                    $('.error').fadeIn();
                }else { // S'il n'est pas vide on vérifie s'il y a une verification supplémentaire sur le champ
                    var name = $(this).attr('name');
                    if(name == 'email') {
                        var regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/igm;
                        if (regex.test($(this).val()) == false) {
                            nbChampVide++;
                            $(this).addClass('error');
                            $(this).parent().append("<div class='error'>Veuillez renseigner une adresse email valide.</div>");
                            $('.error').fadeIn();
                        }else {
                            $(this).addClass('valid');
                        }
                    }else if(name == 'telephone') {
                        var regexPhone = /^((\+|00)33\s?|0)[1-7](\s?\d{2}){4}$/;
                        if (regexPhone.test($(this).val()) == false) {
                            nbChampVide++;
                            $(this).addClass('error');
                            $(this).parent().append("<div class='error'>Veuillez renseigner un numéro de téléphone valide.</div>");
                            $('.error').fadeIn();
                        }else {
                            $(this).addClass('valid');
                        }
                    }else {
                        $(this).addClass('valid');
                    }
                }
            }
        });

        // On fait une vérification à la volée ensuite
        $('.webform-submission-form input:not(.webform-button--submit, [type="file"])').focusout(function() {
            var name = $(this).attr('name');
            if(name == 'email') {
                var regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/igm;
                if (regex.test($(this).val()) == false) {
                    $(this).removeClass('valid');
                    $(this).addClass('error');
                    $(this).parent().children('div.error').remove();
                    $(this).parent().append("<div class='error'>Veuillez renseigner une adresse email valide.</div>");
                    $('.error').fadeIn();
                }else {
                    $(this).addClass('valid');
                    $(this).removeClass('error');
                    $(this).parent().children('div.error').remove();
                }
            }else if(name == 'telephone') {
                var regexPhone = /^((\+|00)33\s?|0)[1-7](\s?\d{2}){4}$/;
                if (regexPhone.test($(this).val()) == false) {
                    $(this).removeClass('valid');
                    $(this).addClass('error');
                    $(this).parent().children('div.error').remove();
                    $(this).parent().append("<div class='error'>Veuillez renseigner un numéro de téléphone valide.</div>");
                    $('.error').fadeIn();
                }else {
                    $(this).addClass('valid');
                    $(this).removeClass('error');
                    $(this).parent().children('div.error').remove();
                }
            }else {
                if($(this).attr('required') == 'required' && ($(this).val() != "" && $(this).val() != " ")) {
                    $(this).addClass('valid');
                    $(this).removeClass('error');
                    $(this).parent().children('div.error').remove();
                }else {
                    var textError = $(this).attr('data-webform-required-error');
                    $(this).addClass('error');
                    $(this).removeClass('valid');
                    if($(this).parent().children('div.error').length == 0) {
                        $(this).parent().append( "<div class='error'>" + textError + "</div>" );
                        $('.error').fadeIn();
                    }
                }
            }
        });

        $('.webform-submission-form select').change(function() {
            if($(this).val() == '' || $(this).val() == ' ') {
                $(this).addClass('error');
                $(this).removeClass('valid');
                if($(this).parent().children('div.error').length == 0) {
                    $(this).parent().append('<div class="error">' + $(this).attr('data-webform-required-error') + '</div>');
                    $('.error').fadeIn();
                }
            }else {
                $(this).addClass('valid');
                $(this).removeClass('error');
                $(this).parent().children('div.error').remove();
            }
        });

        $('.checkboxes--wrapper.required .fieldset-wrapper .form-checkboxes .js-form-item input').change(function() {
            if($(this).prop('checked') == true) $(this).parent().parent().parent().parent().children('.error').remove();
        });
        $('input[type="checkbox"].required').change(function() {
            if($(this).prop('checked') == true) $(this).parent().children('.error').remove();
        });

        if(nbChampVide != 0) {
            e.preventDefault();
            $("html, body").animate({ scrollTop: $('.error').offset().top - 125 }, 500);
        }else {
            // Si c'est l'envoi du formulaire de téléchargement d'un livre blanc, on l'ajoute dans la liste d'intéressement SendInBlue
            if($(this).parent().parent().parent().attr('id') == 'telecharger') {
                e.preventDefault();
                var email =  $(this).parent().parent().children('.form-item-email').children('input').val();
                var nom =  $(this).parent().parent().children('.form-item-nom').children('input').val();
                var prenom =  $(this).parent().parent().children('.form-item-prenom').children('input').val();
                $('.sendinblueform input[name="email"]').val(email);
                $('.sendinblueform input[name="nom"]').val(nom);
                $('.sendinblueform input[name="prenom"]').val(prenom);
                $('.sendinblueform input[name="botOrNotBot"]').val('imNotBot');
                var checkedInput = $(this).parent().parent().children('.form-item-inscription-a-la-newsletter').children('input').is(":checked");
                $.ajax({
                    type: "GET",
                    url: $('.sendinblueform').attr('action'),
                    data: $('.sendinblueform').serialize(), // serializes the form's elements.
                    success: function(data) {
                        if(checkedInput) {
                            $('.sendinblueform-newsletter input[name="email_newsletter"]').val(email);
                            $('.sendinblueform-newsletter input[name="botOrNotBot_newsletter"]').val('imNotBot');
                            $.ajax({
                                type: "GET",
                                url: $('.sendinblueform-newsletter').attr('action'),
                                data: $('.sendinblueform-newsletter').serialize(), // serializes the form's elements.
                                success: function(data) {
                                    $('#telecharger form').submit();
                                },
                                error: function() {
                                    $('#telecharger form').submit();
                                }
                            });
                        }else {
                            $('#telecharger form').submit();
                        }
                    },
                    error: function() {
                        if(checkedInput) {
                            $('.sendinblueform-newsletter input[name="email_newsletter"]').val(email);
                            $('.sendinblueform-newsletter input[name="botOrNotBot_newsletter"]').val('imNotBot');
                            $.ajax({
                                type: "GET",
                                url: $('.sendinblueform-newsletter').attr('action'),
                                data: $('.sendinblueform-newsletter').serialize(), // serializes the form's elements.
                                success: function(data) {
                                    $('#telecharger form').submit();
                                },
                                error: function() {
                                    $('#telecharger form').submit();
                                }
                            });
                        }else {
                            $('#telecharger form').submit();
                        }
                    }
                });
            }
        }
    }

    function verifClickDimensionsForm(e) {
        // vérification des saisies utilisateurs
        var nbChampVide = 0;
        $('div.error').remove();
        $('select.error').removeClass('error');
        $('select.valid').removeClass('valid');
        $('input.error').removeClass('error');
        $('input.valid').removeClass('valid');

        // On vérifie la saisie des champs obligatoire
        $('#clickdimensionsForm .minSize3 > div input[type="text"]').each(function() {
            if($(this).parent().children('input[name="reqField"]').length !== 0) {
                var textError = $(this).parent().children('input[name="reqField"]').attr('requrederrormsg');
                if($(this).val() == "" || $(this).val() == " ") { // On vérifie que le champ n'est pas vide
                    nbChampVide++;
                    $(this).addClass('error');
                    $(this).parent().append( "<div class='error'>" + textError + "</div>" );
                    $('.error').fadeIn();
                }else { // S'il n'est pas vide on vérifie s'il y a une verification supplémentaire sur le champ
                    var name = $(this).attr('leadfield');
                    if(name == 'emailaddress1') {
                        var regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/igm;
                        if (regex.test($(this).val()) == false) {
                            nbChampVide++;
                            $(this).addClass('error');
                            if(window.location.href.indexOf('agena3000.com/fr') !== -1) {
                              var textError = "Veuillez renseigner une adresse email valide.";
                            }else {
                              var textError = "Please enter a valid email address.";
                            }

                            $(this).parent().children('div.error').remove();
                            $(this).parent().append( "<div class='error'>" + textError + "</div>" );
                            $('.error').fadeIn();
                        }else {
                            $(this).addClass('valid');
                        }
                    }else if(name == 'address2_telephone1' || name == 'telephone1' || name == 'telephone2') {
                      var regexPhone = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
                      if (regexPhone.test($(this).val()) == false) {
                        nbChampVide++;
                        $(this).addClass('error');
                        if(window.location.href.indexOf('agena3000.com/fr') !== -1) {
                          var textError = "Veuillez renseigner un numéro de téléphone valide.";
                        }else {
                          var textError = "Please enter a valid phone number.";
                        }

                        $(this).parent().children('div.error').remove();
                        $(this).parent().append( "<div class='error'>" + textError + "</div>" );
                        $('.error').fadeIn();
                      }else {
                        $(this).addClass('valid');
                      }
                    }else {
                        $(this).addClass('valid');
                    }
                }
            }
        });

        // On fait une vérification à la volée ensuite
        $('#clickdimensionsForm .minSize3 > div input[type="text"]').focusout(function() {
            var name = $(this).attr('leadfield');
            if(name == 'emailaddress1') {
                var regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/igm;
                if (regex.test($(this).val()) == false) {
                    $(this).removeClass('valid');
                    $(this).addClass('error');
                    if(window.location.href.indexOf('agena3000.com/fr') !== -1) {
                      var textError = "Veuillez renseigner une adresse email valide.";
                    }else {
                      var textError = "Please enter a valid email address.";
                    }

                    $(this).parent().children('div.error').remove();
                    $(this).parent().append( "<div class='error'>" + textError + "</div>" );
                    $('.error').fadeIn();
                }else {
                    $(this).addClass('valid');
                    $(this).removeClass('error');
                    $(this).parent().children('div.error').remove();
                }
            }else if(name == 'address2_telephone1' || name == 'telephone1' || name == 'telephone2') {
                var regexPhone = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
                if (regexPhone.test($(this).val()) == false) {
                  $(this).addClass('error');
                  $(this).removeClass('valid');
                  if(window.location.href.indexOf('agena3000.com/fr') !== -1) {
                    var textError = "Veuillez renseigner un numéro de téléphone valide.";
                  }else {
                    var textError = "Please enter a valid phone number.";
                  }

                  $(this).parent().children('div.error').remove();
                  $(this).parent().append( "<div class='error'>" + textError + "</div>" );
                  $('.error').fadeIn();
              }else {
                  $(this).addClass('valid');
                  $(this).removeClass('error');
                  $(this).parent().children('div.error').remove();
              }
            }else {
                if($(this).parent().children('input[name="reqField"]').length != 0 && ($(this).val() != "" && $(this).val() != " ")) {
                    $(this).addClass('valid');
                    $(this).removeClass('error');
                    $(this).parent().children('div.error').remove();
                }else {
                    var textError = $(this).parent().children('input[name="reqField"]').attr('requrederrormsg');
                    $(this).addClass('error');
                    $(this).removeClass('valid');
                    if($(this).parent().children('div.error').length == 0) {
                        $(this).parent().append( "<div class='error'>" + textError + "</div>" );
                        $('.error').fadeIn();
                    }
                }
            }
        });

        // On vérifie s'il y a des select list obligatoire
        $('#clickdimensionsForm select').each(function () {
            if($(this).parent().children('input[name="reqField"]').length != 0) {
                if($(this).val() == '' || $(this).val() == ' ' || $(this).val() == '-1') {
                    var textError = $(this).parent().children('input[name="reqField"]').attr('requrederrormsg');
                    $(this).addClass('error');
                    $(this).parent().append('<div class="error">' + textError + '</div>');
                    $('.error').fadeIn();
                    nbChampVide++;
                }
            }
        });

        // On fait une vérification à la volée ensuite sur les select list
        $('#clickdimensionsForm select').change(function() {
            if($(this).parent().children('input[name="reqField"]').length != 0 && ($(this).val() == '' || $(this).val() == ' ' || $(this).val() == '-1')) {
                var textError = $(this).parent().children('input[name="reqField"]').attr('requrederrormsg');
                $(this).addClass('error');
                $(this).removeClass('valid');
                if($(this).parent().children('div.error').length == 0) {
                    $(this).parent().append('<div class="error">' + textError + '</div>');
                    $('.error').fadeIn();
                }
            }else {
                $(this).addClass('valid');
                $(this).removeClass('error');
                $(this).parent().children('div.error').remove();
            }
        });

        // On vérifie que l'utilisateur a coché les cases RGPD
        $('#clickdimensionsForm input[type="checkbox"]').each(function () {
            if($(this).parent().children('span').children('.requiredStar').length != 0 && $(this).prop( "checked" ) == false) {
                if(window.location.href.indexOf('agena3000.com/fr') !== -1) {
                  $(this).parent().append('<div class="error">Veuillez cocher la case ci-dessus pour envoyer votre message.</div>');
                }else if(window.location.href.indexOf('agena3000.com/en') !== -1) {
                  $(this).parent().append('<div class="error">Please check the box above to send your message.</div>');
                }else {
                $(this).parent().append('<div class="error">Vink het vakje hierboven aan om uw bericht te verzenden.</div>');
              }
                $('.error').fadeIn();
                nbChampVide++;
            }
        });

      // On vérifie que l'email a été renseigné pour le formulaire de centre d'abonnement
      if($('#centerabo #clickdimensionsForm .EmailComponent').val() === "" || $('#centerabo #clickdimensionsForm .EmailComponent').val() === " ") {
        if(window.location.href.indexOf('agena3000.com/fr') !== -1) {
          var errorTxt = "Veuillez renseigner une adresse email.";
        }else if(window.location.href.indexOf('agena3000.com/en') !== -1) {
          var errorTxt = "Please enter your email.";
        }else {
          var errorTxt = "Voer uw e-mailadres in.";
        }
        $('#centerabo #clickdimensionsForm .EmailComponent').addClass('error');
        $('#centerabo #clickdimensionsForm .EmailComponent').parent().append("<div class='error'>"+errorTxt+"</div>");
        $('#centerabo .error').fadeIn();
      }else {
        var regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/igm;
        if(window.location.href.indexOf('agena3000.com/fr') !== -1) {
          var errorTxt = "Veuillez renseigner une adresse email valide.";
        }else if(window.location.href.indexOf('agena3000.com/en') !== -1) {
          var errorTxt = "Please enter a valid email address.";
        } else {
          var errorTxt = "Voer een geldig e-mailadres in.";
        }
        if (regex.test($('#clickdimensionsForm .EmailComponent').val()) == false) {
          nbChampVide++;
          $('#centerabo #clickdimensionsForm .EmailComponent').addClass('error');
          $('#centerabo #clickdimensionsForm .EmailComponent').parent().append("<div class='error'>"+errorTxt+"</div>");
          $('#centerabo .error').fadeIn();
        }else {
          $('#centerabo #clickdimensionsForm .EmailComponent').addClass('valid');
        }
      }

        if(nbChampVide !== 0) {
            $("html, body").animate({ scrollTop: $('.error').offset().top - 125 }, 500);
        }else {
           $('#clickdimensionsForm #btnSubmit').click();
        }
    }

    // Fonction pour gérer les checkbox Click Dimensions si elles buguent
    function clickDimensionInputCenter() {
      $('#clickdimensionsForm .minSize3 span').click(function (e) {
        e.preventDefault();
        var inputIsChecked = $(this).parent().children('input').prop('checked');
        if(!$(this).hasClass('checked') && !inputIsChecked && firstClick === 0) checkboxByClickDimensions = false;
        if(!checkboxByClickDimensions) {
          if(inputIsChecked) {
            $(this).removeClass('isChecked');
            $(this).parent().children('input').prop('checked', false);
          }else {
            $(this).addClass('isChecked');
            $(this).parent().children('input').prop('checked', true);
          }
        }
        firstClick++;
      });
    }

    // Fonction qui permet de montrer / cacher le mega menu
    function showMegaMenu() {
        if($(window).width() >= 1200) {
            $(this).addClass('open');
            $('.openSubmenuBtn').addClass('active');
            $('.navigation-submenu').slideDown(400);
            $('.navigation-submenu').mouseleave(function() {
                $('.open').removeClass('open');
                $('.navigation-submenu').slideUp(400);
                $('.openSubmenuBtn').removeClass('active');
            });
        }
    }

    // Fonction qui permet d'afficher / cacher les sous menu du menu responsive
    function adjustLinksInResponsiveMenu() {
        if($('.openSubmenuBtn').length == 0) {
            if($('#block-navigationprincipale').length !== 0) {
                $('#block-navigationprincipale ul > li > ul').parent().append('<div class="openSubmenuBtn">Ouvrir le sous-menu</div>');
            }else if($('#block-navigationprincipaleenglish').length !== 0) {
              $('#block-navigationprincipaleenglish ul > li > ul').parent().append('<div class="openSubmenuBtn">Open submenu</div>');
            }else {
                $('#block-navigationprincipaledutch ul > li > ul').parent().append('<div class="openSubmenuBtn">Submenu openen</div>');
            }
            $('.navigation:not(.sticky) .openSubmenuBtn').click(openSubMenuWithBtn);
        }
    }

    // Fonction qui permet d'afficher le mega menu sur desktop
    function showHideMenuResponsive() {
        if($(this).hasClass('open')) {
            $('.open').removeClass('open');
            $('.fadebg').fadeOut(200);
            $('.openMenu').removeClass('openMenu');
            $('html, body').removeAttr('style');
        }else {
            $('.burger, .btn-close').addClass('open');
            $('.fadebg').fadeIn(200);
            $('#block-navigationprincipale, #block-navigationprincipaleenglish, #block-navigationprincipaledutch').addClass('openMenu');
            $('html, body').css('overflow', 'hidden');
        }
    }

    // Fonction qui permet d'adapter le menu en fonction de la résolution
    function adaptMenu() {
        if($(window).width() >= 1200) {
            $('.responsivelink').parent().hide();
            $('.fadebg').fadeOut(100);
        }else {
            $('.responsivelink').parent().removeAttr('style');
        }

        if($(window).width() >= 760) initScrollReveal();
    }

    // Fonction qui permet d'affiche le méga menu avec le bouton flèche
    function openSubMenuWithBtn() {
        if($(window).width() >= 1200) {
            if($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).parent().children('a').removeClass('open');
                $('.navigation-submenu').slideUp(400);
            }else {
                $(this).addClass('active');
                $(this).parent().children('a').addClass('open');
                $('.navigation-submenu').slideDown(400);
            }

            $('.navigation-submenu').mouseleave(function() {
                $('.openSubmenuBtn').removeClass('active');
                $('.open').removeClass('open');
                $('.navigation-submenu').slideUp(400);
            });
        }else {
            if($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).parent().children('ul').slideUp(300);
            }else {
                $(this).addClass('active');
                $(this).parent().children('ul').slideDown(300);
            }
        }
    }

    // Fonction qui permet d'activer le slider sur les grilles de logo en repsonsive
    function adaptGridLogosBlock() {
      var settingsGridLogos = {
        dots: true,
        arrows: true,
        infinite: false,
        variablewidth: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [{
          breakpoint: 5000,
          settings: 'unslick'
        },{
          breakpoint: 760,
          settings: {
            dots: false,
            arrows: true,
            slidesToShow: 3,
            slidesToScroll: 2
          }
        }, {
          breakpoint: 576,
          settings: {
            dots: false,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]};
      var settingsPictosBlock = {
        dots: true,
        arrows: true,
        infinite: false,
        variablewidth: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [{
          breakpoint: 5000,
          settings: 'unslick'
        },{
          breakpoint: 760,
          settings: {
            dots: false,
            arrows: true,
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }, {
          breakpoint: 576,
          settings: {
            dots: false,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
      };
      if($('.gridlogosblock').length !== 0) var gridSlick = $('.gridlogosblock-content').slick(settingsGridLogos);
      if($('.pictosblock').length !== 0) var pictosSlick = $('.pictosblock-pictos').slick(settingsPictosBlock);
      $(window).on('resize', function() {
        if($(window).width() < 760 && $('.gridlogosblock').length !== 0) {
          if(!gridSlick.hasClass('slick-initialized')) $('.gridlogosblock-content').slick(settingsGridLogos);
        }
        if($(window).width() < 760 && $('.pictosblock').length !== 0) {
          if(!pictosSlick.hasClass('slick-initialized')) $('.pictosblock-pictos').slick(settingsPictosBlock);
        }
      });
    }

    // Fonction qui permet de gérer le scroll sur les ancres
    function detectIfAncre(e) {
        var url = $(this).attr('href');
        var target = $(this).attr('target');
        if(url.indexOf('#') != -1 && url != '#' && target != "_blank" && url != '#cookies') {
            e.preventDefault();
            var offset = $(url).offset().top - 100;
            $('html, body').animate({scrollTop: offset}, 1200);
        }
    }

    // Fonction qui permet d'afficher les modales Youtube
    function showModalVideo() {
        let videoId = $(this).attr('data-video');
        $('.modalvideo').find('.youtube_player').attr('videoID', videoId);
        if($('.modalvideo').find('.youtube_player').find('iframe').length !== 0) {
          let urlVideo = $('.modalvideo').find('.youtube_player').find('iframe').attr('src').split('?');
          $('.modalvideo').find('.youtube_player').find('iframe').attr('src','//www.youtube-nocookie.com/embed/' + videoId + '?' + 'autoplay=1');
        }
        $('.modalvideo').addClass('openingModal');
        $('.modalvideo').fadeIn(400);
        $('html, body').css('overflow', 'hidden');
        $('.modalvideo-close').click(function() {
            $('.modalvideo').fadeOut(300);
            $('.modalvideo').removeClass('openingModal');
            $('.modalvideo iframe').each(function() {
                $(this).attr('src', $(this).attr('src'));
            });
            $('html, body').removeAttr('style');
        });
    }

    function showModalHeaderVideo() {
        $('#youtubemodalHeader').addClass('openingModal');
        $('#youtubemodalHeader').fadeIn(400);
        $('html, body').css('overflow', 'hidden');
        $('.modalvideo-close').click(function() {
            $('.modalvideo').fadeOut(300);
            $('.modalvideo').removeClass('openingModal');
            $('.modalvideo iframe').each(function() {
                $(this).attr('src', $(this).attr('src'));
            });
            $('html, body').removeAttr('style');
        });
    }

    // Fonction qui permet d'initialiser la carte sur la page Contact
    function initContactMap() {
        if($('#mapContact').length != 0) {

            var map = L.map('mapContact', {
                center: [47.0638923, -0.8710914000000685],
                zoom: 13,
                attributionControl: false,
                minZoom: 8,
            });

            L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png', { attribution: '&copy; AGENA3000', attributionControl: false, minZoom: 8 }).addTo(map);

            var myIcon = L.divIcon({
                className: 'cluster',
                iconSize: [35, 47],
                iconAnchor: [15, 47],
                popupAnchor:  [0, -47]
            });

            L.marker([47.0638923, -0.8710914000000685], {icon: myIcon}).addTo(map).bindPopup("<strong>Siège Social</strong><br/>88 Rue du Paradis<br/>49300 Cholet");
        }
    }

    // Fonction qui permet d'appliquer les filtres sur la page ressources
    function applyFilter() {
        $('.views-exposed-form').submit();
    }

    // Fonction qui permet d'afficher / cacher le bloc de recherche Drupal
    function showHideSearchBlock() {
        if($(this).hasClass('active')) {
            $('.search .btn-search').removeClass('active');
            $('.search-form').slideUp(400);
        }else {
            $('.search .btn-search').addClass('active');
            $('.search-form').slideDown(400);
        }
    }

    // Fonction qui permet de s'inscrire à la newsletter Agena 3000
    function testNewsletterForm(e) {
        $('.error-msg').fadeOut(200);
        var name = $('.newsletterblock .EmailComponent').attr('name');
        var regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/igm;
        if (regex.test($('.newsletterblock .EmailComponent').val()) == false) {
            $('.newsletterblock .EmailComponent').addClass('error');
            if($('.newsletterblock div.error-msg').length == 0 && $('.newsletterblock .form-fr').length != 0) $('.newsletterblock .form').append("<div class='error-msg'>Veuillez renseigner une adresse email valide.</div>");
            if($('.newsletterblock div.error-msg').length == 0 && $('.newsletterblock .form-en').length != 0) $('.newsletterblock .form').append("<div class='error-msg'>Please enter a valid email address.</div>");
            $('.error-msg').fadeIn();
        } else {
            $('.newsletterblock .EmailComponent').addClass('valid');
            $('div.error-msg').fadeOut();
            $('.newsletterblock form').submit();
        }
    }

    // Fonction qui permet de changer de slide
    function showNextPrevSlide() {
        $('.landingpage-slider .leftslide').addClass('hide');
        $('.landingpage-slider .rightslide').addClass('hide');

        if($(this).attr('class') == 'nextbutton') {
            var nextSlide = $('.sliders .current').next();
            $('.sliders .current').removeClass('current');
            if(nextSlide.length != 0) {
                nextSlide.addClass('current');
                var leftTextSlide = nextSlide.attr('data-text-left');
                var rightTextSlide = nextSlide.attr('data-text-right');
                var imageSlide = nextSlide.attr('data-img');
                var largerRightText = nextSlide.attr('data-text-right-larger');
            }else {
                $('.sliders .slide-1').addClass('current');
                var leftTextSlide = $('.sliders .slide-1').attr('data-text-left');
                var rightTextSlide = $('.sliders .slide-1').attr('data-text-right');
                var imageSlide = $('.sliders .slide-1').attr('data-img');
                var largerRightText = $('.sliders .slide-1').attr('data-text-right-larger');
            }
        }else {
            var prevSlide = $('.sliders .current').prev();
            $('.sliders .current').removeClass('current');
            if(prevSlide.length != 0) {
                prevSlide.addClass('current');
                var leftTextSlide = prevSlide.attr('data-text-left');
                var rightTextSlide = prevSlide.attr('data-text-right');
                var imageSlide = prevSlide.attr('data-img');
                var largerRightText = prevSlide.attr('data-text-right-larger');
            }else {
                $('.sliders div:last-child').addClass('current');
                var leftTextSlide = $('.sliders div:last-child').attr('data-text-left');
                var rightTextSlide = $('.sliders div:last-child').attr('data-text-right');
                var imageSlide = $('.sliders div:last-child').attr('data-img');
                var largerRightText = $('.sliders div:last-child').attr('data-text-right-larger');
            }
        }

        setTimeout(function() {
            $('.landingpage-slider .rightslide').css('background-image', 'url("' + imageSlide + '")');
            $('.landingpage-slider .leftslide .text').html(leftTextSlide);
            $('.landingpage-slider .rightslide .text').html(rightTextSlide);
            if(largerRightText == 1) {
                $('.landingpage-slider .rightslide .text').addClass('larger');
            }else {
                $('.landingpage-slider .rightslide .text').removeClass('larger');
            }
            setTimeout(function() {
                $('.landingpage-slider .leftslide').removeClass('hide');
                $('.landingpage-slider .rightslide').removeClass('hide');
            }, 350);
        }, 500);
    }

    // Fonction qui permet d'ajuster le placement des formulaires des LP
    function adjustLandingPageForm() {
        if($('.landingpage').length != 0) {
            $('.landingpage-textintro').removeAttr('style');

            if($(window).width() >= 1000) {
                var headerHeight = $('.landingpage-header').innerHeight();
                var introTextHeight = $('.landingpage-textintro').innerHeight();
                var formHeight = $('.landingpage .formblock').innerHeight();
                var topForm = $('.landingpage .formblock').offset().top;

                if((headerHeight + introTextHeight) < (formHeight + topForm)) {
                    if($(window).width() >= 1000 && $(window).width() < 1200) {
                        var paddingToAdd = (formHeight + topForm) - (headerHeight + introTextHeight) + 40;
                    }else {
                        var paddingToAdd = (formHeight + topForm) - (headerHeight + introTextHeight) - 20;
                    }
                    $('.landingpage-textintro').css('padding-bottom', paddingToAdd + 'px');
                }
            }
        }
    }

    // Fonction qui permet d'afficher/cacher la réponse d'une question dans le bloc FAQ
    function showHideFaqAnwser() {
      if($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).children('.question-answer').slideUp(300);
      }else {
        $(this).addClass('active');
        $(this).children('.question-answer').slideDown(300);
      }
    }


